import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { useParams } from "react-router-dom";
import { getJobDetail } from "../redux/slices/jobSlices/getJobDetailSlice";
import { userDetails } from "../redux/slices/userSlices/userDetailsSlice";
import JobDetail from "./JobDetail";
import JobDetailV2 from "./JobDetailV2";

const JobDetailVersioning = () => {
  const dispatch = useAppDispatch();
  const { jobId } = useParams<{
    jobId: string;
    companyName: string;
  }>();
  const { userInfo: user } = useAppSelector((state: any) => state.userDetails);
  const { jobData } = useAppSelector((state) => state.getJobDetails);

  useEffect(() => {
    if (!user) {
      dispatch(userDetails());
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (jobId) dispatch(getJobDetail({ jobId: jobId }));
  }, [jobId, dispatch]);

  return <>{jobData?.version === 5 ? <JobDetailV2 /> : <JobDetail />}</>;
};

export default JobDetailVersioning;
